// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2XvmY","requiredAsterisk":"Info_requiredAsterisk__1wWDX"};